import { Channel } from '@/types/channel.types';
import { EventType } from '@/types/projects.types';

export function isTownhallChannel(value?: Channel['type']): boolean {
  return value === EventType.Townhall;
}

export function isWebinarChannel(value?: Channel['type']): boolean {
  return value === EventType.Webinar;
}
